import { ErrorType, LoadedType, RequestType } from 'common/actions/referrer';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
